import BoldDecorator from "./bold/viewer";
import FontSizeDecorator from "./font-size/viewer";
import ItalicDecorator from "./italic/viewer";
import UnderlineDecorator from "./underline/viewer";
const nodeViewDecorators = [
  BoldDecorator,
  ItalicDecorator,
  UnderlineDecorator,
  FontSizeDecorator
];
export {
  nodeViewDecorators
};
//# sourceMappingURL=viewer.js.map
